(function () {
  'use strict';
  var S = window.themeSettings || {};

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || S.moneyFormat || '{{amount}} €';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.formatMoney = formatMoney;

  /* ---------- Overlays (menu / cart) ---------- */
  var lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input');
    if (f) f.focus();
  }
  function closeOverlay(el) {
    if (!el) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-nav]:not([hidden]), [data-cart-drawer]:not([hidden])').forEach(closeOverlay);
  });

  var nav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-expanded', 'true'); openOverlay(nav); });
  });
  document.querySelectorAll('[data-nav-close]').forEach(function (b) {
    b.addEventListener('click', function () { closeOverlay(nav); });
  });

  /* ---------- Cart ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count; c.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var box = drawer.querySelector('[data-cart-items]');
    var total = drawer.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      box.innerHTML = '<p class="drawer__empty">O teu carrinho está vazio.</p>';
    } else {
      box.innerHTML = '<ul class="cart-lines">' + cart.items.map(function (it, i) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" width="72" height="72" loading="lazy">' : '';
        var meta = '';
        if (it.variant_title && !/default title/i.test(it.variant_title)) meta += '<p class="line__meta">' + esc(it.variant_title) + '</p>';
        if (it.selling_plan_allocation) meta += '<p class="line__meta">' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>';
        return '<li class="line">' +
          '<a class="line__img" href="' + it.url + '">' + img + '</a>' +
          '<div><a class="line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + meta +
          '<div class="qty"><button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Diminuir">−</button>' +
          '<span class="qty__input" aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Aumentar">+</button></div>' +
          '<button type="button" class="line__remove" data-line="' + (i + 1) + '" data-q="0">Remover</button></div>' +
          '<div class="line__price">' + formatMoney(it.final_line_price) + '</div></li>';
      }).join('') + '</ul>';
    }
    var bar = drawer.querySelector('[data-ship-bar]');
    if (bar && S.freeShipping > 0) {
      bar.hidden = false;
      var left = S.freeShipping - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / S.freeShipping * 100));
      bar.querySelector('[data-ship-fill]').style.width = pct + '%';
      bar.querySelector('[data-ship-text]').textContent = left > 0
        ? (S.freeShippingText || '').replace('[valor]', formatMoney(left))
        : S.freeShippingDone;
    }
  }

  function fetchCart() {
    return fetch(S.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openCart() {
    fetchCart().then(function (c) { renderCart(c); openOverlay(drawer); });
  }
  window.openCart = openCart;

  if (drawer) {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!S.cartDrawer) return;
        e.preventDefault(); openCart();
      });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeOverlay(drawer); });
    });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b) return;
      b.disabled = true;
      fetch(S.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.q)) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  /* ---------- Product ---------- */
  document.querySelectorAll('[data-product-section]').forEach(initProduct);

  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form.buy__form');
    var idInput = root.querySelector('[data-variant-id]');
    var planInput = root.querySelector('[data-plan-input]');
    var planSelect = root.querySelector('[data-plan-select]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcText = atcLabel ? atcLabel.textContent : '';
    var errEl = root.querySelector('[data-atc-error]');
    var stock = root.querySelector('[data-stock]');
    var sticky = document.querySelector('[data-sticky-atc]');
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function mode() {
      var r = root.querySelector('[data-ptype-radio]:checked');
      return r ? r.value : 'once';
    }
    function planId() { return planSelect ? planSelect.value : null; }

    function update() {
      var v = current;
      var isSub = mode() === 'sub' && planId() && v.plans[planId()] != null;
      var now = isSub ? v.plans[planId()] : v.price;
      var was = isSub ? v.price : v.compare;

      if (idInput) idInput.value = v.id;
      if (planInput) { planInput.disabled = !isSub; planInput.value = isSub ? planId() : ''; }

      var pNow = root.querySelector('[data-price-now]');
      var pWas = root.querySelector('[data-price-was]');
      var pSave = root.querySelector('[data-price-save]');
      if (pNow) pNow.textContent = formatMoney(now);
      if (pWas) { pWas.hidden = !(was > now); pWas.textContent = formatMoney(was); }
      if (pSave) { pSave.hidden = !(was > now); if (was > now) pSave.textContent = 'Poupas ' + Math.round((was - now) / was * 100) + '%'; }

      var subNow = root.querySelector('[data-sub-now]');
      var subWas = root.querySelector('[data-sub-was]');
      var pid = planId();
      if (subNow && pid && v.plans[pid] != null) subNow.textContent = formatMoney(v.plans[pid]);
      if (subWas) subWas.textContent = formatMoney(v.price);
      var onceNow = root.querySelector('[data-once-now]');
      var onceWas = root.querySelector('[data-once-was]');
      if (onceNow) onceNow.textContent = formatMoney(v.price);
      if (onceWas) { onceWas.hidden = !(v.compare > v.price); onceWas.textContent = formatMoney(v.compare); }

      if (atc) { atc.disabled = !v.available; atcLabel.textContent = v.available ? atcText : 'Esgotado'; }
      if (stock) {
        var th = Number(stock.dataset.threshold || 0);
        stock.textContent = (v.tracked && v.available && v.inv > 0 && v.inv < th) ? 'Só restam ' + v.inv + ' unidades' : '';
      }
      var sp = document.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = formatMoney(now);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-variant-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        current = variants.find(function (v) { return String(v.id) === r.value; }) || current;
        if (current.media) goToMedia(current.media);
        update();
      });
    });
    root.querySelectorAll('[data-ptype-radio]').forEach(function (r) { r.addEventListener('change', update); });
    if (planSelect) planSelect.addEventListener('change', update);

    /* quantity */
    var qInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) + Number(b.dataset.qty));
      });
    });

    /* gallery */
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function goToMedia(id) {
      var slide = root.querySelector('.gallery__slide[data-media-id="' + id + '"]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goToMedia(t.dataset.thumb); }); });
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var id = en.target.dataset.mediaId;
            thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
          }
        });
      }, { root: track, threshold: [0.6] });
      track.querySelectorAll('.gallery__slide').forEach(function (s) { io.observe(s); });
    }

    /* add to cart */
    if (form) {
      var afterAdd = root.dataset.afterAdd || 'drawer';
      form.addEventListener('submit', function (e) {
        if (afterAdd !== 'checkout' && (!S.cartDrawer || !drawer)) return;
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
        fetch(S.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Não foi possível adicionar ao carrinho.');
            if (afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
            openCart();
          })
          .catch(function (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } })
          .finally(function () { atc.disabled = !current.available; atc.removeAttribute('aria-busy'); });
      });
    }

    /* sticky bar */
    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky');
      var obs = new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      });
      obs.observe(atc);
      var sb = sticky.querySelector('[data-sticky-btn]');
      if (sb) sb.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    update();
  }

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- Bundle builder ---------- */
  document.querySelectorAll('[data-builder]').forEach(function (root) {
    var size = Number(root.dataset.size || 3);
    var picks = [];
    var slots = root.querySelector('[data-builder-slots]');
    var total = root.querySelector('[data-builder-total]');
    var hint = root.querySelector('[data-builder-hint]');
    var submit = root.querySelector('[data-builder-submit]');
    var err = root.querySelector('[data-builder-error]');
    function draw() {
      slots.innerHTML = '';
      for (var i = 0; i < size; i++) {
        var li = document.createElement('li');
        var p = picks[i];
        if (p) {
          li.className = 'builder__slot';
          li.innerHTML = (p.img ? '<img src="' + p.img + '" alt="">' : '') + '<span>' + esc(p.title) + '</span><button type="button" class="line__remove" data-i="' + i + '" aria-label="Remover ' + esc(p.title) + '">Remover</button>';
        } else {
          li.className = 'builder__slot is-empty';
          li.textContent = i + 1;
        }
        slots.appendChild(li);
      }
      var sum = picks.reduce(function (a, p) { return a + p.price; }, 0);
      total.textContent = formatMoney(sum);
      var left = size - picks.length;
      hint.textContent = left > 0 ? 'Falta' + (left > 1 ? 'm ' : ' ') + left + ' produto' + (left > 1 ? 's' : '') : 'Pack completo';
      submit.disabled = left > 0;
      root.querySelectorAll('[data-builder-add]').forEach(function (b) { if (!b.dataset.soldout) b.disabled = left === 0; });
    }
    root.querySelectorAll('[data-builder-add]').forEach(function (b) {
      if (b.disabled) b.dataset.soldout = '1';
      b.addEventListener('click', function () {
        if (picks.length >= size) return;
        picks.push({ id: Number(b.dataset.id), title: b.dataset.title, img: b.dataset.img, price: Number(b.dataset.price) });
        draw();
      });
    });
    slots.addEventListener('click', function (e) {
      var r = e.target.closest('[data-i]');
      if (!r) return;
      picks.splice(Number(r.dataset.i), 1);
      draw();
    });
    submit.addEventListener('click', function () {
      var map = {};
      picks.forEach(function (p) { map[p.id] = (map[p.id] || 0) + 1; });
      var items = Object.keys(map).map(function (id) { return { id: Number(id), quantity: map[id], properties: { _pack: 'Monta o teu pack' } }; });
      submit.disabled = true;
      err.hidden = true;
      fetch(S.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || 'Não foi possível adicionar o pack.');
          picks = []; draw();
          if (drawer && S.cartDrawer) openCart(); else window.location.href = S.routes.cartPage;
        })
        .catch(function (e) { err.textContent = e.message; err.hidden = false; submit.disabled = false; });
    });
    draw();
  });
})();
